import { Link } from 'react-router-dom';
import { usePortalDestination } from './PortalDestinationContext';

const MORE_PAGES = ['bills', 'verification', 'clinical'];
const MORE_ITEMS = [
  { page: 'bills', label: 'Bills & Layaway' },
  { page: 'verification', label: 'Document Review' },
  { page: 'clinical', label: 'Clinical Info' },
];

/** Rx root tabs — shared by Prescriptions, Refills and the "More" group (Bills, Document Review, Clinical Info). */
export const PortalRxTabs = ({ active }) => {
  const { href } = usePortalDestination();
  const topActive = MORE_PAGES.includes(active) ? 'more' : active;
  return (
    <div className="portal-rx-tabs-wrap" data-testid="portal-rx-tabs-wrap">
      <nav className="portal-rx-tabs" aria-label="Prescription services" data-testid="portal-rx-tabs">
        <Link to={href('prescriptions')} className={topActive === 'prescriptions' ? 'is-active' : ''}
          aria-current={topActive === 'prescriptions' ? 'page' : undefined} data-testid="portal-rx-tab-prescriptions">
          Prescriptions
        </Link>
        <Link to={href('refills')} className={topActive === 'refills' ? 'is-active' : ''}
          aria-current={topActive === 'refills' ? 'page' : undefined} data-testid="portal-rx-tab-refills">
          Refills
        </Link>
        <Link to={href('bills')} className={topActive === 'more' ? 'is-active' : ''}
          aria-current={topActive === 'more' ? 'page' : undefined} data-testid="portal-rx-tab-more">
          More
        </Link>
      </nav>
      {topActive === 'more' && (
        <nav className="portal-rx-more-tabs" aria-label="More prescription services" data-testid="portal-rx-more-subnav">
          {MORE_ITEMS.map(item => (
            <Link key={item.page} to={href(item.page)} className={active === item.page ? 'is-active' : ''}
              aria-current={active === item.page ? 'page' : undefined} data-testid={`portal-rx-more-${item.page}`}>
              {item.label}
            </Link>
          ))}
        </nav>
      )}
    </div>
  );
};
